import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	buttonLabel: {
		id: 'software-deployments-header-meatball-menu.button-label',
		defaultMessage: 'More',
		description: 'Label for the menu button',
	},
	manageInstalledAppsButtonLabel: {
		id: 'software-deployments-header-meatball-menu.manage-installed-apps-button-label',
		defaultMessage: 'Manage installed apps',
		description: 'Button text for inviting user to manage installed applications',
	},
	manageProjectFeaturesButtonLabel: {
		id: 'software-deployments-header-meatball-menu.manage-project-features-button-label',
		defaultMessage: 'Manage project features',
		description: 'Button text for inviting user to manage project features',
	},
	usingDeploymentsButtonLabel: {
		id: 'software-deployments-header-meatball-menu.using-deployments-button-label',
		defaultMessage: 'Using Deployments in Jira',
		description:
			'Button text for inviting user to open the modal which prescribes a list of steps required to use deployments in Jira',
	},
});
